import {
  type CreatePolicyInput,
  CreateBackupPolicyApi,
  DeleteBackupPolicyApi,
  ListBackupPoliciesApi,
  type BackupPolicyConfig,
  type Configuration,
  UpdateBackupPolicyApi,
} from '@repo/api-gw-sdk';
import type { SWRConfiguration } from 'swr';

import type { HttpClient } from './httpClient';

const basesUrl = '/backup-policies';

export const backupPolicy = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const listPoliciesApi = new ListBackupPoliciesApi(config);
  const createApi = new CreateBackupPolicyApi(config);
  const editApi = new UpdateBackupPolicyApi(config);
  const deleteApi = new DeleteBackupPolicyApi(config);
  return {
    useList: (swrOptions?: SWRConfiguration) =>
      httpClient.executeWithConfig(
        listPoliciesApi.listPolicies.bind(listPoliciesApi),
        basesUrl,
        '',
        swrOptions,
        currentProjectId
      ),
    create: (policy: CreatePolicyInput) =>
      createApi.createPolicy(currentProjectId, policy),
    update: (policy: BackupPolicyConfig) =>
      editApi.updatePolicy(policy.id, currentProjectId, policy),
    delete: (policyId: string) =>
      deleteApi.deletePolicy(policyId, currentProjectId),
  };
};
